import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormArray, FormControl, Validators } from '@angular/forms';
import {
  ApplicationAppEntityApplicationRead,
  LocationDecisionAppEntityLocationDecisionWrite,
  RoadOccupationPurposeFeeAppEntityDictionaryRoadOccupationPurposeFee
} from '../../../../../../../openapi';
import {
  AdPlacementStageForm,
  AdPlacementStageFormValue,
  toAdPlacementStageFormValue
} from './ad-placement-stage.form';

export function occupationsToAdPlacementRoadOccupationFormValues(application?: ApplicationAppEntityApplicationRead | null): AdPlacementRoadOccupationFormValue[] {
  return (application?.roadOccupations || [])
    .sort((a, b) => (b?.ordinalNumber || 0) - (a?.ordinalNumber || 0))
    .map(v => ({
      stages: [...v?.stages || []]
        ?.sort((a, b) => (b?.ordinalNumber || 0) - (a?.ordinalNumber || 0))
        ?.map(s => toAdPlacementStageFormValue(s)) || [],

      locationDecisions: v?.locationDecisions?.map(v => ({
        decisionNumber: v.decisionNumber,
        decisionDate: v.decisionDate
      })) || []
    }));
}

export interface AdPlacementRoadOccupationFormValue {
  locationDecisions: LocationDecisionAppEntityLocationDecisionWrite[];
  stages: AdPlacementStageFormValue[];
}

@Injectable()
export class AdPlacementRoadOccupationForm extends AppForm {
  constructor() {
    super({
      locationDecisions: new FormControl([], {
        nonNullable: true,
        validators: [Validators.minLength(1), Validators.maxLength(255)]
      }),
      stages: new FormArray([
        new AdPlacementStageForm()
      ])
    });
  }

  public addStage(fees: RoadOccupationPurposeFeeAppEntityDictionaryRoadOccupationPurposeFee[]): void {
    const f = new AdPlacementStageForm();
    f.createPurposeFeesForms(fees, [], true);
    this.stages.push(f);
  }

  public removeStage(i: number): void {
    this.stages.removeAt(i);
  }

  public get stages(): FormArray {
    return this.get('stages') as FormArray;
  }

  public getStageForms(): AdPlacementStageForm[] {
    return this.stages.controls as AdPlacementStageForm[];
  }

  public get locationDecisions(): FormControl | null {
    return this.get('locationDecisions') as FormControl | null;
  }

  public override patchFormValues(data: {
    value: AdPlacementRoadOccupationFormValue | null;
    purposeFeeCollection: RoadOccupationPurposeFeeAppEntityDictionaryRoadOccupationPurposeFee[];
  }) {
    super.patchFormValues(data.value);

    this.stages.clear();
    (data.value?.stages || []).forEach(stage => {
      const sf = new AdPlacementStageForm();
      sf.patchFormValues({
        ...stage
      });
      sf.createPurposeFeesForms(data.purposeFeeCollection, stage.purposeFees, true);
      this.stages.push(sf);
    });

    if (!this.stages.length) {
      const sf = new AdPlacementStageForm();
      sf.createPurposeFeesForms(data.purposeFeeCollection, [], true);
      this.stages.push(sf);
    }
  }

  public get values(): AdPlacementRoadOccupationFormValue {
    return {
      ...this.value,
      stages: this.getStageForms().map(f => f.values)
    };
  }
}
